<template>
  <div class="light-apply">
    <div v-if="this.orderStatus.payStatus !== undefined">
      <div v-if="this.orderStatus.payStatus === 10" class="light-apply-success">
        <img
          src="~@/assets/images/success.svg"
          v-if="this.orderStatus.payStatus === 10"
        />
        <img src="~@/assets/images/processing.svg" v-else />
        <div class="light-apply-success-text">{{ bookingStatus }}</div>
        <div class="light-apply-success-order-id">
          {{ `訂單編號：${orderStatus.orderId}` }}
        </div>
      </div>
      <div v-else class="light-apply-success">
        <img src="~@/assets/images/failure.svg" />
        <div class="light-apply-success-text">申請失敗</div>
        <div class="light-apply-success-order-id">
          付款失敗
        </div>
      </div>
    </div>
    <div v-else class="light-apply-success">
      <img src="~@/assets/images/processing.svg" />
      <div class="light-apply-success-text">資料查詢中</div>
      <div class="light-apply-success-order-id">
        {{ `訂單編號：${orderStatus.orderId}` }}
      </div>
    </div>
    <div class="light-query-record" v-if="showQueryButton">
      <div class="temple-button-text" @click="clickQueryRecord">
        查詢已申請紀錄
      </div>
    </div>
  </div>
</template>

<script scoped>
export default {
  name: 'ServiceLightStep5',
  props: {
    orderStatus: {},
    showQueryButton: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    bookingStatus() {
      switch (this.orderStatus.payStatus) {
        case 0:
        case 1:
          return '等待付款中';

        case 10:
          return '申請成功';

        default:
          return '申請失敗';
      }
    },
  },
  methods: {
    clickQueryRecord() {
      this.$router.push({ path: '/service?page=4' });
    },
  },
};
</script>

<style>
.light-apply {
  margin: 0px 5px 0px 5px;
}

.light-apply-success {
  margin: 100px 0px 100px 0px;
  align-items: center;
  text-align: center;
}

.light-apply-success-text {
  margin: 5px 0px 5px 0px;
  font-size: 12px;
  color: #000000;
}

.light-apply-success-order-id {
  font-size: 16px;
  font-weight: bold;
  color: #000000;
}

.light-query-record {
  margin-top: 50px;
  align-items: center;
  display: flex;
  justify-content: center;
}

@media (min-width: 768px) {
  .light-apply-success-order-id {
    margin-top: 20px;
  }
}
</style>
